import { Entity, Field } from 'typegraph';

@Entity({many: "resources"})
export default class Resource {

	@Field()
	public url: string;

	@Field()
	public type: string;
}



// WEBPACK FOOTER //
// ./src/core/util/resource/Resource.ts